// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"SkeletonLoader_skeletonContainer__a+OGx","skeletonItem":"SkeletonLoader_skeletonItem__WxnUE","shimmer":"SkeletonLoader_shimmer__OLmXZ"};